// extracted by mini-css-extract-plugin
module.exports = {"root":"instagram_root__2FBfu","contentArea":"instagram_contentArea__2KSCL","inverted":"instagram_inverted__3Hsbi"};